import { ActionReducer, createFeature, createReducer, on } from '@ngrx/store';
import { RESIDENT_CALL_REASON_ACTIONS, RESIDENT_CALL_REASON_API_ACTIONS } from './resident-call-reason.actions';
import { IReportState } from '../../../../../shared/components/report-page/report-page.component';
import { ResidentCallReasons } from '../../../../../../graphql';

export const RESIDENT_CALL_REASON_STATE_KEY = 'resident-call-reason';

export interface IResidentCallReasonState extends IReportState<ResidentCallReasons[]> {}

export const residentCallReasonState: IResidentCallReasonState = {
  data: [],
  loading: false,
  error: null,
  totalCount: 0,
  activeViewLabel: null,
};

const reducer: ActionReducer<IResidentCallReasonState> = createReducer<IResidentCallReasonState>(
  residentCallReasonState,
  on(RESIDENT_CALL_REASON_API_ACTIONS.get, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(RESIDENT_CALL_REASON_API_ACTIONS.success, (state, { rows, totalCount }) => ({
    ...state,
    loading: false,
    data: rows,
    totalCount,
  })),
  on(RESIDENT_CALL_REASON_API_ACTIONS.error, (state, { error }) => ({
    ...state,
    loading: false,
    totalCount: 0,
    error,
  })),
  on(RESIDENT_CALL_REASON_ACTIONS.setActiveView, (state, { viewName }) => ({
    ...state,
    activeViewLabel: viewName,
  })),
);

export const RESIDENT_CALL_REASON_REDUCER = createFeature({
  name: RESIDENT_CALL_REASON_STATE_KEY,
  reducer,
});
